import UserAttendedIcon from "icons/UserAttendedIcon";
import { Container } from "./styles";

const ListItemPendingCaption = ({
    isPending
}) => {
    return isPending !== null && (
        <Container>
            {!isPending 
            ? <>
                <UserAttendedIcon/>
                <span>Listo</span>
            </> 
            : <span>Pendiente</span>}
        </Container>
    );
}

export default ListItemPendingCaption;